'use client'

import { ImageCarouselForItemCard } from '@/app/ui/components/imageCarousel'
import { articleItemType } from '@/lib/article/server'
import { serviceType } from '@/lib/service/server'

type ArticleItemCardProps = {
  item: articleItemType
  service: serviceType
}

export const ArticleItemCard = ({ item, service }: ArticleItemCardProps) => {
  return (
    <div className="my-4 gap-3 p-2 rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition-shadow duration-200 w-full md:w-[48%] flex flex-col">
      {/* 商品画像 */}
      <div className="w-full flex-shrink-0 rounded-lg overflow-hidden bg-gray-50">
        <ImageCarouselForItemCard
          hideSkipButton={true}
          images={item.item_images.map((img) => {
            return {
              url: img.image_url,
              alt: item.name,
            }
          })}
        />
      </div>

      {/* 商品情報 */}
      <div className="flex flex-col gap-1 flex-1 min-w-0">
        {/* 商品名 */}
        <h3 className="text-lg font-semibold text-gray-800 leading-snug line-clamp-2 mt-4">
          {item.name}
        </h3>

        <div className="flex items-center gap-1 justify-between mt-auto">
          {/* 価格 */}
          <p className="text-lg font-bold text-gray-900">
            ¥{item.price.toLocaleString()}
          </p>
        </div>

        {/* カートボタン */}
        <button
          className="w-[full] my-1 text-center gap-1.5 text-white text-base font-semibold px-4 py-4 rounded-md shadow transition-opacity duration-200 hover:opacity-80"
          style={{ backgroundColor: service.main_color }}
          onClick={(e) => {
            e.preventDefault()
            window.location.href = `/item/${item.item_id}`
          }}
        >
          商品の詳細を見る
        </button>
      </div>
    </div>
  )
}
